import { addCalendarDays, type CalendarDate } from "../shared/calendar-date";

/** JavaScript weekday: Sunday = 0 through Saturday = 6. */
export type Weekday = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export function validateWeekday(value: number): Weekday {
  if (!Number.isInteger(value) || value < 0 || value > 6) throw new Error("Check-in weekday must be from 0 to 6");
  return value as Weekday;
}

export function weekdayOf(date: CalendarDate): Weekday {
  return new Date(`${date}T00:00:00.000Z`).getUTCDay() as Weekday;
}

/** Most recent nominated check-in day, which is also the start of the new plan. */
export function alignedWeekStart(date: CalendarDate, nominatedCheckInWeekday: Weekday): CalendarDate {
  const offset = (weekdayOf(date) - nominatedCheckInWeekday + 7) % 7;
  return addCalendarDays(date, -offset);
}

export function checkInDateForWeekStart(startDate: CalendarDate): CalendarDate {
  return addCalendarDays(startDate, 7);
}
